// Builds the save payload for the VSM "Add New Status Record" panel from
// only the fields the user actually touched, using a baseline snapshot
// taken when the row was last loaded from the server. Without this, saving
// the panel sent the whole (possibly stale) row, so a user who only meant
// to change one field would silently re-save every other field's old value
// and clobber anything another user had changed on that vehicle in the
// meantime.

export function snapshotStatusRecordFields(item, fieldKeys) {
  const snapshot = {}
  fieldKeys.forEach(key => {
    snapshot[key] = item ? item[key] : undefined
  })
  return snapshot
}

export function buildStatusRecordPayload(baseline, item, fieldKeys) {
  const payload = { name: item.name }
  fieldKeys.forEach(key => {
    if (!baseline || baseline[key] !== item[key]) {
      payload[key] = item[key]
    }
  })
  return payload
}

// VSM pages replace `items`/`items_full` wholesale on every load/reload,
// including on a background timer. If a user is actively editing a row's
// notes or "Add New Status Record" fields when a refresh lands, the input's
// bound value silently resets to whatever the server currently has - and the
// eventual blur/save then writes that (usually blank/stale) value back,
// clobbering what the user typed even though only one person was involved.
//
// This re-applies the in-progress field values from the previous items list
// onto the freshly-loaded items, for any row name flagged as actively being
// edited, so a refresh can't stomp on it mid-edit.
export function preserveActiveEdits(previousItems, freshItems, activeEditNames, fieldKeys) {
  if (!previousItems || !previousItems.length || !activeEditNames || !freshItems) {
    return freshItems
  }

  const previousByName = {}
  previousItems.forEach(item => {
    if (item && item.name != null) {
      previousByName[item.name] = item
    }
  })

  freshItems.forEach(item => {
    if (item && activeEditNames[item.name] && previousByName[item.name]) {
      const previous = previousByName[item.name]
      fieldKeys.forEach(key => {
        item[key] = previous[key]
      })
    }
  })

  return freshItems
}
